import { useState, useEffect, useRef } from "react";
import CloseIcon from "../../../assets/crossIcon.svg";
import { PreinitiateServices } from "../../../services/PreinitiateServices";
import { AuthServices } from "../../../services/AuthServices";
import { CaseServices } from "../../../services/CaseServices";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import { getUser, logOut } from "../../../config/user";
import DeleteIcon from "../../../assets/deleteIcon.svg";
import TooltipIcon from "../../../assets/tooltipTriangle.svg";
import MapDocumentToUrl from "./MapDocumentToUrl";
import UnmapDocument from "./UnmapDocument";
import RejectionPopUp from "./RejectionPopUp";
import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import AddIcon from "../../../assets/addMoreIcon.svg";
import PdfIcon from "../../../assets/pdfIcon.png";
import ImagesGallery from "./ImagesGallery";
import ImagesGalleryHospitalPersona from "../../../hospitalPersona/imageGallery/ImageGalleryHospitalPersona";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ReferenceRejectionHistoryModal from "./ReferenceRejectionHistoryModal";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import { useNavigate } from "react-router-dom";
import { pdfjs, Document, Page } from "react-pdf";
// import { PDFDocument } from "pdf-lib";
import { saveAs } from "file-saver";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { toast } from "react-toastify";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PreinitiateModal = ({
  selectedCase,
  isOpen,
  subStatusList,
  AllCases,
  currentCommandCenterStage,
}) => {
  const [referenceDocuments, setReferenceDocuments] = useState([]);
  const [groupedReferenceDocuments, setGroupedReferenceDocuments] = useState(
    [],
  );
  const [selectedPdf, setSelectedPdf] = useState(-1);
  const [isDocUploading, setDocUploading] = useState(false);
  const [description, setDescription] = useState(null);
  const [docUrl, setDocUrl] = useState(null);
  const [reUploadedDocUrl, setReuploadedDocUrl] = useState(null);
  // const [sequence, setSequence] = useState(1);
  const [pdfDocument, setPdfDocument] = useState(null);
  // const [documentName, setDocumentName] = useState(null);
  const [images, setImages] = useState([]);
  const [referencePendingModal, setReferencePendingModal] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [isReuploading, setReuploading] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [documentType, setDocumentType] = useState("ADMISSIONDOCUMENT");
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isRejectionPopUp, setRejectionPopUp] = useState(false);
  const [isReferenceRejectionHistoryOpen, setIsReferenceRejectionHistoryOpen] =
    useState(false);
  const [
    selectedReferenceRejectionDocuments,
    setSelectedReferenceRejectionDocuments,
  ] = useState([]);
  const [openModalId, setOpenModalId] = useState(false);
  const [mapMultipleDocument, setMultipleDocument] = useState(false);
  const [openImagesGallery, setOpenImagesGallery] = useState(false);
  const [UnmapDocId, setUnmapDocId] = useState(null);
  const [anyDocRejected, setAnyDocRejected] = useState(false);
  const [currrentCommandCenterStage, setcurrrentCommandCenterStage] =
    useState(null);
  const [reason, setReason] = useState("");
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const reUploadFileRef = useRef(null);
  const currentRole = useSelector((store) => store.currentRole.value);
  const user = getUser();
  const userRoles = user?.roles;
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handleReUploadButtonClick = () => {
    reUploadFileRef.current.click();
  };

  const filteredStage = subStatusList?.filter(
    (status, idx) => status.id === 176,
  );

  //Method to upload the pdf doc
  async function uploadDocument(event) {
    setDocUploading(true);
    try {
      const file = event.target.files[0];
      const fileType = file.type.split("/")[0];
      setDescription(event.target.files[0].name.slice(0, -4));
      if (
        fileType === "application" &&
        file.name.toLowerCase().endsWith(".pdf")
      ) {
        // setDescription(event.target.files[0].name.slice(0, -4));
        const uri = URL.createObjectURL(file);
        const _PDF_DOC = await pdfjs.getDocument(uri).promise;
        setPdfDocument(_PDF_DOC);
      } else if (fileType === "image") {
        const imageBlob = URL.createObjectURL(file);
        setImages([imageBlob]);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  }
  //Method to get the image list from the uploaded pdf document
  async function getImageList() {
    const imagesList = [];

    try {
      for (let i = 1; i <= pdfDocument.numPages; i++) {
        const canvas = document.createElement("canvas");
        canvas.setAttribute("class", "canv");
        const page = await pdfDocument.getPage(i);
        const viewport = page.getViewport({ scale: 3 });
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        const renderContext = {
          canvasContext: canvas.getContext("2d"),
          viewport: viewport,
        };

        await page.render(renderContext).promise;
        await new Promise((resolve) => {
          canvas.toBlob((blob) => {
            if (blob) {
              const blobUrl = URL.createObjectURL(blob);
              imagesList.push(blobUrl);
              if (i === pdfDocument.numPages) {
                setImages(imagesList);
              }
            }
            resolve();
          }, "image/png");
        });
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  }
  //Method to upload the image list's blob data to s3 bucket
  const uploadImages = async () => {
    let data = new FormData();
    for (let index = 0; index < images.length; index++) {
      let image = images[index];
      if (!(image instanceof Blob)) {
        const response = await fetch(image);
        image = await response.blob();
      }
      data.append("images", image, `${description + "_" + index}.jpeg`);
    }
    try {
      let res = await AuthServices.uploadPdfToImage(data, setPercentage);
      console.log("Image data resonse from apis", res.data.urls);
      setDocUrl(res?.data?.urls);
      setPdfDocument(null);
      setImages([]);
      window.alert("Image uploaded successfully");
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setDocUploading(false);
  };
  const uploadImage = async (e) => {
    setDocUploading(true);
    setDescription(e.target.files[0].name.slice(0, -4));
    try {
      let data = new FormData();
      data.append("image", e.target.files[0]);
      let res = await AuthServices.splitAndUploadImage(data);
      window.alert("Image uploaded successfully");
      setDocUrl(res?.data?.urls);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setDocUploading(false);
  };
  const reUploadImage = async (e) => {
    setReuploading(true);
    try {
      let data = new FormData();
      data.append("image", e.target.files[0]);
      let res = await AuthServices.uploadImage(data);

      await PreinitiateServices.updateReferenceDocument(
        {
          documentUrl: res?.data?.url,
        },
        selectedDoc.id,
      );
      window.alert("Image uploaded successfully");
      getDocumentsData();
      setReuploadedDocUrl(res?.data?.url);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setReuploading(false);
  };

  const getDocumentsData = async () => {
    setIsLoading(true);
    setSelectedDocuments([]);
    try {
      const response = await PreinitiateServices.getReferenceDocuments(
        selectedCase.id,
        documentType,
      );

      const tempData = [...response.data].sort((a, b) => {
        if (a.parentId === null && b.parentId !== null) {
          return -1; // Place null parentId first
        }
        if (a.parentId !== null && b.parentId === null) {
          return 1; // Place null parentId first
        }
        return (a.parentId || "").localeCompare(b.parentId || ""); // Compare strings if both are not null
      });

      let modifiedData = [];
      let groupedDocs = [];
      for (let doc of tempData) {
        if (doc.parentId) {
          if (groupedDocs.length === 0) {
            groupedDocs.push(doc);
          } else {
            if (doc.parentId === groupedDocs[0].parentId) {
              groupedDocs.push(doc);
            } else {
              modifiedData.push({
                parentId: groupedDocs[0].parentId,
                docs: groupedDocs,
              });
              groupedDocs = [];
              groupedDocs.push(doc);
            }
          }
        } else {
          modifiedData.push({ parientId: null, docs: [doc] });
        }
      }
      if (groupedDocs.length > 0) {
        modifiedData.push({
          parentId: groupedDocs[0].parentId,
          docs: groupedDocs,
        });
      }
      console.log("reference documents::", response?.data);

      setReferenceDocuments(response.data);
      setGroupedReferenceDocuments(modifiedData);
      setAnyDocRejected(
        response?.data?.some((doc) => doc.status === "REJECTED"),
      );
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setIsLoading(false);
  };
  const handleStatusChange = async () => {
    setIsLoading(true);
    const filteredStage = subStatusList?.filter(
      (status, idx) => status.id === 176,
    );
    if (reason) {
      try {
        const postStageData = {
          hsaStage: filteredStage[0]?.hsaWebStatus,
          commandCeneterStage: filteredStage[0]?.commandCenterStageStatus,
          nextStepUser: filteredStage[0]?.nextStepUser,
          caseDetails: [
            {
              query: "",
              queryResponse: reason,
            },
          ],
        };
        const stageResponse = await CaseServices.updateSubMasterStage(
          selectedCase.id,
          postStageData,
        );
        window.alert(stageResponse.data.message);
        setReferencePendingModal(false);
        isOpen(false);

        navigate("/dashboard/ActiveCases");
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      window.alert("Reason is Required");
    }
    setIsLoading(false);
  };
  const handleDocumentSelect = (doc) => {
    //if selected document is not present in the list then this block will get executed
    if (
      selectedDocuments.findIndex(
        (document) => document?.docs[0].id === doc?.docs[0].id,
      ) === -1
    ) {
      setSelectedDocuments([...selectedDocuments, doc]);
    }
    //If document is already present in the list then in that case we are removing it from the list
    else {
      const modifiedData = selectedDocuments.filter(
        (document) => document?.docs[0]?.id !== doc?.docs[0]?.id,
      );
      setSelectedDocuments(modifiedData);
    }
  };

  //This method is to save the updated document data
  const updateDocumentData = async () => {
    const data = {
      documentUrl: reUploadedDocUrl,
    };
    try {
      if (selectedDoc.id) {
        await PreinitiateServices.updateReferenceDocument(data, selectedDoc.id);
      }

      setSelectedDoc(null);
      setReuploadedDocUrl(null);
      getDocumentsData();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  //This is called to delete a selected document
  const deleteDocument = async (docId) => {
    try {
      const response = await PreinitiateServices.deleteReferenceDocument(docId);

      getDocumentsData();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  //This method is called to save the newly uploaded document
  const addDocument = async () => {
    setIsSaving(true);
    if (docUrl) {
      const sequence =
        referenceDocuments.length > 0
          ? referenceDocuments[referenceDocuments.length - 1]?.sequence + 1
          : 1; //here we are generating sequence for the newly added document
      // console.log("sequence:", sequence);
      // console.log("reference documents:", referenceDocuments);
      const modifiedData = docUrl?.map((url, idx) => {
        return {
          parentId: `${description?.slice(0, 4)}${new Date().getTime()}${
            referenceDocuments.length > 0
              ? referenceDocuments[referenceDocuments.length - 1].sequence + 1
              : 1 + docUrl.length
          }${docUrl.length}`,
          caseId: selectedCase.id,
          documentUrl: url,
          sequence: sequence + idx,
          description: `${description}_${idx}`,
          documentType: documentType,
        };
      });
      try {
        await PreinitiateServices.addReferenceDocuments(modifiedData);
        toast.success("Documents Added Successfully ");
        getDocumentsData();
      } catch (error) {
        handleApiErrorResponses(error);
      }
      setDescription(null);
    }
    setPercentage(0);
    setIsSaving(false);
    setDocUrl(null);
  };
  const getMappedDocumentName = (mappedDocs) => {
    if (mappedDocs.length > 0) {
      const modifiedData = mappedDocs?.map((doc) => doc.documentName);
      return modifiedData.join(", ");
    }
  };
  const hasReferenceRejectionReason = (documents = []) => {
    return documents.some((document) => {
      const currentReason = document?.rejectionReason?.trim();

      const historyReason =
        Array.isArray(document?.history?.rejectionReason) &&
        document.history.rejectionReason.some((item) =>
          item?.rejectionReason?.trim(),
        );

      return Boolean(currentReason || historyReason);
    });
  };
  useEffect(() => {
    getDocumentsData();
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [documentType]);
  useEffect(() => {
    pdfDocument && getImageList();
  }, [pdfDocument]);
  useEffect(() => {
    images.length > 0 && uploadImages();
  }, [images]);

  return (
    <div className="fixed top-5 left-0 w-screen h-screen flex justify-center items-center bg-[#017C5780] z-[1200]">
      <div className="relative bg-white rounded-[16px] w-[90%]  2xl:w-[75%] h-[80%] p-4 xl:p-8">
        <div className="absolute flex gap-2 top-4 right-4 xl:top-5 xl:right-12">
          {currentRole?.role?.roleName?.toLowerCase().includes("team") &&
            referenceDocuments &&
            referenceDocuments.length > 0 && (
              <div
                className="flex items-center gap-1 text-sm text-white bg-[#017C57] px-4 py-1 rounded-full cursor-pointer"
                onClick={() => setOpenImagesGallery(true)}
              >
                <CollectionsOutlinedIcon />
                View Gallery
              </div>
            )}
          {openImagesGallery && (
            <ImagesGallery
              setOpen={setOpenImagesGallery}
              data={referenceDocuments}
            />
          )}
          {currentRole?.role?.roleName?.toLowerCase().includes("team") &&
            selectedDocuments &&
            selectedDocuments.length > 0 && (
              <div
                className="flex items-center gap-1 text-sm text-white bg-[#017C57] px-4 py-1 rounded-full cursor-pointer"
                onClick={() => setMultipleDocument(true)}
              >
                <CollectionsOutlinedIcon />
                Map Multiple Documents
              </div>
            )}
          {mapMultipleDocument && (
            <MapDocumentToUrl
              caseId={selectedCase.id}
              selectedDoc={selectedDocuments}
              isOpen={setMultipleDocument}
              getDocumentsData={getDocumentsData}
            />
          )}
          <img
            src={CloseIcon}
            height={30}
            width={30}
            alt="close-icon"
            onClick={() => {
              isOpen(false);
              AllCases && AllCases();
            }}
            className="cursor-pointer"
          />
        </div>
        <div className="absolute top-4 left-4 xl:top-5 xl:left-8 flex gap-2 items-center mb-2 xl:mb-4">
          <div className="text-[#191919] font-semibold text-xl xl:text-2xl ">
            Documents Added
          </div>
          <div
            style={{ border: "1px solid #017C57" }}
            className={`text-sm ${
              documentType.includes("ADMISSION")
                ? "text-white bg-[#017C57]"
                : "text-[#017C57]"
            } rounded-full px-5 py-2 cursor-pointer `}
            onClick={() => setDocumentType("ADMISSIONDOCUMENT")}
          >
            Admission
          </div>
          <div
            style={{ border: "1px solid #017C57" }}
            className={`text-sm ${
              documentType.includes("ENHANCEMENT")
                ? "text-white bg-[#017C57]"
                : "text-[#017C57]"
            } rounded-full px-5 py-2 cursor-pointer `}
            onClick={() => setDocumentType("ENHANCEMENTDOCUMENT")}
          >
            Enhancement{" "}
          </div>
          <div
            style={{ border: "1px solid #017C57" }}
            className={`text-sm ${
              documentType.includes("DISCHARGE")
                ? "text-white bg-[#017C57]"
                : "text-[#017C57]"
            } rounded-full px-5 py-2 cursor-pointer `}
            onClick={() => setDocumentType("ONDISCHARGEDOCUMENT")}
          >
            Claim
          </div>
        </div>
        <div className="flex flex-col justify-between h-full">
          <div className="flex flex-col items-center mt-5 overflow-y-scroll mb-2 xl:mb-4 min-h-[50%]">
            {isLoading ? (
              <div className=" mt-12">
                <CircularProgress />
              </div>
            ) : groupedReferenceDocuments &&
              groupedReferenceDocuments.length > 0 ? (
              <div className="grid grid-cols-1 xl:grid-cols-2 justify-center w-[100%] xl:w-[95%] 2xl:w-[90%] gap-x-6 gap-y-4 my-4 xl:my-8">
                {groupedReferenceDocuments?.map((doc, idx) => {
                  return (
                    <div
                      key={idx}
                      style={{
                        border:
                          doc.docs[0]?.status === "REJECTED"
                            ? "1px solid #CF363630"
                            : "1px solid #E4E4E4",
                      }}
                      className={`relative grid grid-cols-2 xl:grid-cols-5 gap-2 gap-y-3 items-center ${
                        doc.docs[0]?.status === "REJECTED"
                          ? "bg-[#FFD6DB80]"
                          : "bg-[#F9F9F9]"
                      } p-2 rounded-[8px]`}
                    >
                      {doc.docs[0]?.status === "MAPPED" && (
                        <div className="absolute flex gap-1 top-1 left-[25%] text-xs font-semibold">
                          {" "}
                          <CheckCircleOutlineOutlinedIcon
                            style={{ color: "#017C57", fontSize: "16px" }}
                          />
                          <div>
                            {doc?.docs[0]?.mappedWith?.split(",").length}
                          </div>
                          <div className="group relative ">
                            <InfoOutlinedIcon
                              style={{
                                color: "#017C57",
                                fontSize: "16px",
                                cursor: "pointer",
                              }}
                              onClick={() => setUnmapDocId(doc.id)}
                            />
                            <div className="absolute w-[200px] hidden group-hover:block  text-xs   z-20">
                              <div className="w-full flex justify-start pl-2">
                                <img src={TooltipIcon} alt="toolti-icon" />
                              </div>
                              <div className="text-[12px] text-center text-white bg-[#017C57] py-2 px-1 rounded-[8px]">
                                {getMappedDocumentName(doc.docs[0]?.mappedDocs)}
                              </div>
                            </div>
                            {UnmapDocId === doc.docs[0].id && (
                              <UnmapDocument
                                refDocId={doc.docs[0].id}
                                mappedDocs={doc.docs[0].mappedDocs}
                                getDocumentsData={getDocumentsData}
                                isOpen={setUnmapDocId}
                              />
                            )}
                          </div>
                        </div>
                      )}
                      <div className="flex items-center justify-center">
                        {doc?.documentUrl?.slice(-3) !== "pdf" &&
                          !doc?.parentId &&
                          currentRole?.role?.roleName
                            ?.toLowerCase()
                            .includes("team") &&
                          doc.status !== "REJECTED" && (
                            <div>
                              <input
                                type="checkbox"
                                onClick={() => handleDocumentSelect(doc)}
                                className="h-[16px] w-[16px] mr-2"
                              />
                            </div>
                          )}

                        {doc.parentId ? (
                          <div className="">
                            <img
                              src={PdfIcon}
                              alt="pdf-icon"
                              width={48}
                              height={48}
                            />
                            {/* {doc.docs[0]?.totalUnreadComments > 0 && (
                              <div className="absolute top-0 right-0 w-[16px] h-[16px] flex justify-center items-center text-[10px] text-white bg-[#ff0000]  rounded-full">
                                {" "}
                                {doc.docs[0]?.totalUnreadComments}
                              </div>
                            )} */}
                            <div
                              className="absolute top-1 right-1 cursor-pointer z-10"
                              onClick={() => setSelectedPdf(idx)}
                            >
                              <div className="relative flex items-center gap-2">
                                {hasReferenceRejectionReason(doc?.docs) && (
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();

                                      const rejectedImages =
                                        doc?.docs?.filter((document) => {
                                          const currentReason =
                                            document?.rejectionReason?.trim();

                                          const historyReason =
                                            Array.isArray(
                                              document?.history
                                                ?.rejectionReason,
                                            ) &&
                                            document.history.rejectionReason.some(
                                              (item) =>
                                                item?.rejectionReason?.trim(),
                                            );

                                          return Boolean(
                                            currentReason || historyReason,
                                          );
                                        }) || [];

                                      setSelectedReferenceRejectionDocuments(
                                        rejectedImages,
                                      );
                                      setIsReferenceRejectionHistoryOpen(true);
                                    }}
                                    className="flex items-center justify-center border-0 bg-transparent p-0 outline-none"
                                  >
                                    <InfoOutlinedIcon
                                      sx={{
                                        fontSize: 20,
                                        color: "#ff0000",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </button>
                                )}

                                <ChatBubbleOutlineOutlinedIcon
                                  style={{ color: "#017c57" }}
                                />

                                {doc.docs[0]?.totalUnreadComments > 0 && (
                                  <div className="absolute -top-2 -right-1 w-[20px] h-[20px] flex justify-center items-center text-[10px] text-white bg-[#ff0000] rounded-full">
                                    {doc.docs[0]?.totalUnreadComments > 99
                                      ? "99+"
                                      : doc.docs[0]?.totalUnreadComments}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className=" w-12 h-12 xl:w-[80px] xl:h-[80px] flex items-center">
                            <img
                              src={doc?.docs[0].documentUrl}
                              alt={`${doc?.docs[0].description}-image`}
                              height={48}
                              width={48}
                              className="object-cover w-12 h-12 xl:w-[80px] xl:h-[80px]"
                            />
                            {/* {doc.docs[0]?.totalUnreadComments > 0 && (
                              <div className="absolute top-0 right-0 w-[16px] h-[16px] flex justify-center items-center text-[10px] text-white bg-[#ff0000]  rounded-full">
                                {" "}
                                {doc.docs[0]?.totalUnreadComments}
                              </div>
                            )} */}
                            <div
                              className="absolute top-1 right-1 cursor-pointer z-10"
                              onClick={() => setSelectedPdf(idx)}
                            >
                              <div className="relative">
                                <div className="absolute right-3 top-3 flex items-center gap-2">
                                  {hasReferenceRejectionReason(doc?.docs) && (
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();

                                        setSelectedReferenceRejectionDocuments(
                                          doc?.docs?.filter((document) => {
                                            const currentReason =
                                              document?.rejectionReason?.trim();

                                            const historyReason = Array.isArray(
                                              document?.history
                                                ?.rejectionReason,
                                            )
                                              ? document.history.rejectionReason.some(
                                                  (item) =>
                                                    item?.rejectionReason?.trim(),
                                                )
                                              : false;

                                            return Boolean(
                                              currentReason || historyReason,
                                            );
                                          }) || [],
                                        );

                                        setIsReferenceRejectionHistoryOpen(
                                          true,
                                        );
                                      }}
                                      className="flex items-center justify-center"
                                    >
                                      <InfoOutlinedIcon
                                        sx={{
                                          fontSize: 20,
                                          color: "#017C57",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </button>
                                  )}
                                  <ChatBubbleOutlineOutlinedIcon
                                    style={{ color: "#017c57" }}
                                  />
                                </div>
                                {doc.docs[0]?.totalUnreadComments > 0 > 0 && (
                                  <div className="absolute -top-2 -right-1 w-[20px] h-[20px] flex justify-center items-center text-[10px] text-white bg-[#ff0000] rounded-full ">
                                    {doc.docs[0]?.totalUnreadComments > 99
                                      ? "99+"
                                      : doc.docs[0]?.totalUnreadComments}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="font-semibold text-sm text-center">
                        {" "}
                        {doc?.docs[0].description}
                      </div>
                      {currentRole?.role?.roleName
                        ?.toLowerCase()
                        .includes("hospital") && (
                        <div className="col-span-2 flex justify-center">
                          {selectedDoc &&
                          selectedDoc?.docs[0].id === doc?.docs[0]?.id &&
                          isReuploading ? (
                            <CircularProgress />
                          ) : (
                            <button
                              style={{
                                borderRadius: "32px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontFamily: "Inter, sans-serif",
                                fontWeight: "600",
                                fontSize: "14px",
                                backgroundColor: "#017c57",
                                color: "white",
                                border: "none",
                                gap: "8px",
                                cursor: "pointer",
                                paddingBlock: "6px",
                                paddingInline: "16px",
                              }}
                              onClick={() => {
                                setSelectedDoc(doc);
                                handleReUploadButtonClick();
                              }}
                            >
                              <FileUploadOutlinedIcon fontSize="small" />{" "}
                              RE-UPLOAD
                            </button>
                          )}

                          {/* <div
                              style={{ border: "1px solid #017C57" }}
                              className="text-sm text-[#017C57] text-center font-semibold bg-white rounded-full px-4 py-2 cursor-pointer "
                              onClick={() => {
                                if (selectedDoc && selectedDoc.id === doc.id) {
                                  updateDocumentData();
                                }
                              }}
                            >
                              Save
                            </div> */}
                        </div>
                      )}
                      {currentRole?.role?.roleName
                        ?.toLowerCase()
                        .includes("hospital") && (
                        <div
                          className="flex justify-center cursor-pointer"
                          onClick={() => deleteDocument(doc.id)}
                        >
                          <img src={DeleteIcon} alt="delete-icon" width={20} />
                        </div>
                      )}
                      {/* {currentRole?.role?.roleName
                          ?.toLowerCase()
                          .includes("hospital") && (
                          
                        )} */}
                      {currentRole?.role?.roleName
                        ?.toLowerCase()
                        .includes("team") && (
                        <div className="hidden xl:block" />
                      )}
                      {
                        <div className="col-span-2 flex justify-around xl:block">
                          {doc.parentId ||
                          doc?.docs[0].status !== "REJECTED" ? (
                            <div>
                              <div
                                style={{ border: "1px solid #017c57" }}
                                className="w-full h-fit  text-[10px] xl:text-xs text-[#017C57] text-center bg-white font-semibold  cursor-pointer rounded-full py-1 px-4 xl:py-2"
                                onClick={() => setOpenModalId(idx)}
                              >
                                Map Document
                              </div>
                              {userRoles?.filter((role) =>
                                role?.role?.roleName
                                  ?.toLowerCase()
                                  .includes("doctor"),
                              )?.length > 0 &&
                                currentCommandCenterStage !==
                                  "Reference Document Pending" &&
                                currentCommandCenterStage !==
                                  "Reference Document Rejected" && (
                                  <div
                                    style={{ border: "1px solid #017c57" }}
                                    className="w-full h-fit text-[10px] xl:text-xs text-[#017C57] text-center bg-white font-semibold cursor-pointer rounded-full px-4 py-1  xl:py-2 xl:mt-1"
                                    onClick={() => {
                                      setSelectedDoc(doc);
                                      setRejectionPopUp(true);
                                      // handleRejectDocument();
                                    }}
                                  >
                                    Review Document
                                  </div>
                                )}
                            </div>
                          ) : (
                            <div className="text-center text-sm text-[#191919] font-semibold t">
                              {" "}
                              REJECTED
                            </div>
                          )}
                        </div>
                      }
                      {isRejectionPopUp && (
                        <RejectionPopUp
                          isOpen={setRejectionPopUp}
                          selectedDoc={selectedDoc}
                          getDocumentsData={getDocumentsData}
                        />
                      )}
                      {/* <ReferenceRejectionHistoryModal
                        open={isReferenceRejectionHistoryOpen}
                        onClose={() => {
                          setIsReferenceRejectionHistoryOpen(false);
                          setSelectedReferenceRejectionDocuments([]);
                        }}
                        documents={selectedReferenceRejectionDocuments}
                      /> */}
                      {openModalId === idx && (
                        <MapDocumentToUrl
                          caseId={selectedCase.id}
                          selectedDoc={[doc]}
                          isOpen={setOpenModalId}
                          getDocumentsData={getDocumentsData}
                        />
                      )}
                    </div>
                  );
                })}
                <ReferenceRejectionHistoryModal
                  open={isReferenceRejectionHistoryOpen}
                  onClose={() => {
                    setIsReferenceRejectionHistoryOpen(false);
                    setSelectedReferenceRejectionDocuments([]);
                  }}
                  documents={selectedReferenceRejectionDocuments}
                />
              </div>
            ) : (
              <div className="flex justify-center items-center text-xl text-[#191919] font-semibold h-full">
                No Document Uploaded
              </div>
            )}
          </div>

          <div>
            {/* Showing upload progress here */}
            {isDocUploading && (
              <div className="flex items-center gap-1">
                <div
                  style={{ width: `${percentage + 1}%` }}
                  className="h-[15px] bg-blue-500 rounded-full"
                />{" "}
                {percentage}%
              </div>
            )}
            <div className="flex justify-center">
              <div
                style={{ border: "1px solid #E4E4E4" }}
                className="w-[100%] xl:w-[90%]  bg-[#F9F9F9] rounded-[16px] p-4 xl:p-5 "
              >
                <div className="flex  justify-between items-center gap-4 ">
                  <div className="text-[18px] font-semibold text-[#191919]">
                    Upload new document
                  </div>
                  <div>
                    {isDocUploading ? (
                      <div>
                        <CircularProgress />
                      </div>
                    ) : (
                      <div>
                        <input
                          type="file"
                          onChange={(e) => uploadDocument(e)}
                          style={{ display: "none" }}
                          ref={fileInputRef}
                          accept=".pdf,.png,.jpg,.jpeg"
                        />
                        <button
                          style={{
                            height: "34px",
                            width: "192px",
                            borderRadius: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontFamily: "Inter, sans-serif",
                            fontWeight: "600",
                            fontSize: "14px",
                            border: "1px solid #017C57",
                            backgroundColor: "white",
                            color: "#017c57",
                            cursor: "pointer",
                            gap: "8px",
                          }}
                          onClick={() => handleButtonClick()}
                        >
                          <FileUploadOutlinedIcon
                            fontSize="small"
                            style={{ color: "#017C57" }}
                          />{" "}
                          UPLOAD
                        </button>
                        <div className="text-xs text-[#797979] text-center mt-1">
                          Files Supported : .pdf, .png. .jpg
                        </div>
                      </div>
                    )}
                  </div>

                  <div className=" w-[100%] xl:w-[328px]">
                    <input
                      type="text"
                      placeholder="Enter doc description"
                      value={description}
                      style={{ border: "1px solid #e4e4e4" }}
                      className="w-full h-[40px] text-[18px] text-[#797979] rounded-[8px]
            pl-[12px] "
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>
                  <div>
                    {isSaving ? (
                      <CircularProgress />
                    ) : (
                      <div
                        style={{ border: "1px solid #017C57" }}
                        className="w-fit flex gap-2 text-sm text-white font-semibold bg-[#017C57] rounded-full px-4 py-2 cursor-pointer"
                        onClick={addDocument}
                      >
                        <img src={AddIcon} alt="add-icon" />
                        ADD DOCUMENT
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              {/* <input
                type="file"
                onChange={(e) => uploadImage(e)}
                style={{ display: "none" }}
                ref={fileInputRef}
              /> */}
              <input
                type="file"
                onChange={(e) => reUploadImage(e)}
                style={{ display: "none" }}
                ref={reUploadFileRef}
                accept="image/*"
              />
            </div>
            {anyDocRejected ||
            currentCommandCenterStage === "Reference Document Pending" ||
            currentCommandCenterStage ===
              "Reference Document Rejected" ? null : (
              <div className="flex justify-center mt-2">
                <div
                  style={{ border: "1px solid #D32F2F" }}
                  className="flex items-center gap-2 text-sm text-white bg-[#D32F2F] font-semibold uppercase px-8 py-2 rounded-full cursor-pointer"
                  title="Change Case Stage to Reference Document Pending"
                  onClick={() => setReferencePendingModal(true)}
                >
                  <NewReleasesOutlinedIcon /> Reference Documents Pending
                </div>
              </div>
            )}
          </div>
          {referencePendingModal && (
            <div className="fixed w-screen h-screen top-0 left-0 bg-[#017C5780] flex justify-center items-center z-[1200]">
              <div className="relative w-[50%] h-[40%] 2xl:h-[30%] bg-[white] rounded-[16px]">
                <div
                  className="absolute top-4 right-4 cursor-pointer"
                  onClick={() => setReferencePendingModal(false)}
                >
                  <img src={CloseIcon} alt="cross-icon" />
                </div>
                <div className="text-xl text-[#191919] text-center font-medium mt-5">
                  Change Case Status
                </div>
                <div className="flex justify-center gap-4 mt-5">
                  <div className="text-[#191919] font-medium">
                    Please Specify Reason *
                  </div>
                  <textarea
                    className="w-[60%] h-[90px] rounded-[8px] p-2"
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
                <div className="flex justify-center">
                  {isLoading ? (
                    <CircularProgress />
                  ) : (
                    <div
                      className="text-sm text-white bg-[#017C57] font-semibold rounded-full px-8 py-2 mt-8 cursor-pointer"
                      onClick={handleStatusChange}
                    >
                      Change Status
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {selectedPdf >= 0 && (
            <ImagesGalleryHospitalPersona
              data={groupedReferenceDocuments[selectedPdf]?.docs}
              setOpen={setSelectedPdf}
              view={true}
              type={"referenceDocument"}
              getDocumentsData={getDocumentsData}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PreinitiateModal;
